<template lang="pug">
  #profile(v-if="user")
    user-tile(v-if="showUserTile" :user="user")
    
    #gallery-wrapper
      gallery(type="profile" :id="user.id")

</template>

<script>
import axios from "axios";

// Components
import UserTile from "@/components/UserTile";
import Gallery from "@/components/Gallery";

export default {
  name: "Profile",
  components: {
    UserTile,
    Gallery
  },
  props: {
    userId: {
      type: String,
      required: false
    },
    showUserTile: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      user: undefined
    };
  },
  mounted() {
    this.loadUser(this.userId);
  },
  methods: {
    loadUser() {
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/users/${
            this.userId ? this.userId : this.$route.params.id
          }`
        )
        .then(response => {
          this.user = response.data.user;
        });
    }
  }
};
</script>

<style lang="stylus" scoped>
#profile {
  #gallery-wrapper {
    margin-top: 20px;
  }
}</style>